// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';

function handleClick() {

    this.onOptionClick(this.onOptionClickValues);

}

const ActionsPopoverListCallback = props => (
    <li>
        <button
            className='button-text'
            onClick={props::handleClick}
        >
            <FormattedMessage id={props.label}/>
        </button>
    </li>
);

ActionsPopoverListCallback.displayName = 'ActionsPopoverListCallback';
ActionsPopoverListCallback.propTypes = {
    label: PropTypes.string.isRequired,
    onOptionClick: PropTypes.func.isRequired,
    onOptionClickValues: PropTypes.object
};

export default ActionsPopoverListCallback;



// WEBPACK FOOTER //
// ./src/shared/components/actions-popover/actions-popover-list-callback.js